/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  ListItemSecondaryAction,
  TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";

import { styled } from "@mui/material/styles";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import ListItemText from "@mui/material/ListItemText";

import IconButton from "@mui/material/IconButton";

import Checkbox from "@mui/material/Checkbox";

import Typography from "@mui/material/Typography";

import { Add } from "@mui/icons-material";

import { db } from "../../firebase";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import "./todo.css";

function generate(element) {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) =>
    React.cloneElement(element, {
      key: value,
    })
  );
}

const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));
function Todo() {
  const [todos, setTodos] = useState([]);
  const [newTodo, setNewTodo] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const ref = collection(db, "todo");

  useEffect(() => {
    const getTodos = async () => {
      const data = await getDocs(ref);
      setTodos(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    getTodos();
  }, []);

  const handleTodoInputChange = (e) => {
    setNewTodo(e.target.value);
  };

  const handleAddTodo = async () => {
    if (newTodo.trim() === "") {
      return;
    }
    const data = await addDoc(ref, { text: newTodo, completed: false });
    setNewTodo("");
    window.location.reload();
  };

  const handleToggleTodo = async (todo) => {
    const userDoc = doc(db, "todo", todo.id);
    const newFields = { completed: !todo.completed };
    await updateDoc(userDoc, newFields);
    window.location.reload();
  };

  const handleDeleteTodo = async (todo) => {
    const todoDoc = doc(db, "todo", todo.id);
    await deleteDoc(todoDoc);
    window.location.reload();
  };
  const cardStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.1)", // Black color with 50% opacity
    color: "black",
  };
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "65vh",
        borderRadius: 0.5,
      }}
    >
      <Card style={cardStyle}>
        <CardContent>
          {isLoading && <CircularProgress color="secondary" />}
          <Typography variant="h4" gutterBottom>
            Todo list
          </Typography>
          <TextField
            label="Add Todo"
            value={newTodo}
            onChange={handleTodoInputChange}
            fullWidth
            inputProps={{ style: { fontSize: 20 } }}
          />

          <Button onClick={handleAddTodo} buttonText={<Add />} />

          <List>
            {todos.map((todo) => (
              <ListItem key={todo.id}>
                <Checkbox
                  checked={todo.completed}
                  onChange={() => handleToggleTodo(todo)}
                />
                <ListItemText primary={todo.text} />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    color="secondary"
                    onClick={() => handleDeleteTodo(todo)}
                  >
                    <Delete />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Container>
  );
}

export default Todo;
